import React from 'react';
import type ServicedeskReportsCustomEditType from '@atlassian/jira-spa-apps-servicedesk-reports-custom-edit/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskReportsCustomEdit = lazyForPaint<
	typeof ServicedeskReportsCustomEditType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-reports-custom-edit", jiraSpaEntry: "async-servicedesk-reports-custom-edit" */ '@atlassian/jira-spa-apps-servicedesk-reports-custom-edit'
		),
	),
);

const AsyncServicedeskReportsCustomEdit = ({ match }: RouteContext): React.JSX.Element => {
	const { reportId } = match.params;
	return (
		<LazyPage
			Page={LazyServicedeskReportsCustomEdit}
			pageId={`spa-apps/servicedesk/reports/custom/${reportId || ''}`}
			shouldShowSpinner
		/>
	);
};

export default AsyncServicedeskReportsCustomEdit;
